import BaseSpace, { SpaceProps as BaseSpaceProps } from 'antd/lib/space'

export interface SpaceProps extends BaseSpaceProps {}

export const Space = (props: SpaceProps): JSX.Element => (
  <>
    <BaseSpace {...props} />
  </>
)

export default Space
